/**
 * Labstep
 */

import { fieldSignatureRequirementDaysToSign } from 'labstep-web/components/SignatureRequirement/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { ISignatureRequirementFormShowEditDaysToSignProps } from './types';

export const SignatureRequirementFormShowEditDaysToSign: React.FC<
  ISignatureRequirementFormShowEditDaysToSignProps
> = ({ signatureRequirement }) => (
  <ShowEditText
    entityName={signatureRequirement.entityName}
    entity={signatureRequirement}
    field={fieldSignatureRequirementDaysToSign}
  >
    {signatureRequirement.days_to_sign}
  </ShowEditText>
);
